export const PROTO_EXTENSION: string = ".proto";
export const RFA_EXTENSION: string = ".rfa";
export const PDF_EXTENSION: string = ".pdf";